export default async function updateState(ref, state) {
  return new Promise((resolve, reject) => {
    ref.setState(state, () => {
      resolve();
    });
  });
}
